<template>
  <div>
    <b-input-group v-for="dim in dimension" :key="dim.value">
      <b-input-group-prepend><label>{{dim.text}}</label></b-input-group-prepend>
      <b-form-input readonly v-model="model[`${dim.value}Info`]" @keyup.13.native="showLkuDimVal(dim)"></b-form-input>
      <b-input-group-append>
        <b-btn text="Button" @click="showLkuDimVal(dim)" :id="dim.value">
          <i class="fa fa-search"></i>
        </b-btn>
      </b-input-group-append>
    </b-input-group>

    <b-modal v-model="lkuDimShow" :hide-footer="true" size="lg"  :title="lkuDimTitle" :centered="true" >
      <div class="lku-dimval">
        <b-row>
            <b-col xl="8" lg="10">
              <b-input-group >
                  <b-input-group-append><span class="ml-2 pt-2 mr-1">Filter</span></b-input-group-append>
                  <b-form-input v-model="tblData.kode" placeholder="code" @keyup.13.native="refresh()"></b-form-input>
                  <b-form-input v-model="tblData.nama" placeholder="name" @keyup.13.native="refresh()" class="ml-1"></b-form-input>
              </b-input-group>
            </b-col>
        </b-row>
      <b-table
        class="mb-0"
        ref="table"
        responsive small 
        striped hover
        :items="data"
        :fields="fields"
        :current-page="tblData.page"
        :per-page="tblData.limit"
        :sort-by.sync="tblData.sortBy"
        :sort-desc.sync="tblData.sortDesc"
        :key="tblData.limit" 
        @row-clicked="selectItem"
      >
          <template v-slot:cell(kode)="data">
            <span v-if="(data.item.judul=='Y')" v-html="data.item.kode" style="font-weight:bold;"></span>
            <span v-else v-html="data.item.kode"></span>
          </template>
          <template v-slot:cell(nama)="data">
            <span v-if="(data.item.judul=='Y')" v-html="data.item.nama" style="font-weight:bold;"></span>
            <span v-else v-html="data.item.nama"></span>
          </template>
          <template v-slot:cell(aktif)="data">
            <span v-if="(data.item.aktif=='0')">NON ACTIVE</span>
          </template>

        </b-table>
      <b-row>
        <b-col cols="4">
          <div class="pt-2">
            Showing {{(tblData.page - 1) * tblData.limit + 1}}
            to <span v-if="((tblData.page * tblData.limit)>tblData.total)">{{tblData.total}}</span> <span v-else>{{tblData.page * tblData.limit}}</span>
            of {{tblData.total}} entries
        </div>        
        </b-col>
        <b-col cols="3">            
            <b-row class="ml-2 mt-2">
              <span class="pt-1 pr-2">Limit per page</span>
              <b-form-select :options="[10, 20, 30, 50, 70, 90, 120]" :plain="true" v-model="tblData.limit"  size="sm" style="width:80px !important;"/>
            </b-row>
        </b-col>
        <b-col cols="5">            
          <b-pagination
            align="right"
            :total-rows="tblData.total"
            :per-page="tblData.limit"
            v-model="tblData.page"
          ></b-pagination>
        </b-col>
      </b-row>
      </div>
    </b-modal>
  </div>
</template>

<style lang="scss">
.lku-dimval {
  td {
    padding: 0;

    a {
      //   border: 1px solid;
      text-decoration: none;
      display: block;
      padding: 0.5rem 0.75rem;
    }
  }
}
</style>


<script>
import dim from "../../apis/dimensionsample";

export default {
  data() {
    return {
      lkuDimShow: false,
      lkuDimTitle: 'Lookup Dimension Value',
      fields: [
          {
            key: "kode",
            label: "Code",
            thStyle: "width:200px",
            sortable: true
          },
          {
            key: "nama",
            label: "Name",
            sortable: true
          },
          {
            key: "aktif",
            label: "Active",
            thStyle: "width:40px",
            sortable: true
          },
      ],
      tblData: {
        page: 1,
        limit: 10,
        total: 0,
        sortBy: 'kode',
        sortDesc: false,
        filter: null,
        total: 0,
        kode: "",nama: "",aktif:'1',DimColName: "Dim1"
      }
    };
  },
  computed: {
    dimension(){
      return this.$store.state.dimension;
    },
    filterNama() {
      return this.tblData.nama;
    },
  },
  watch: {
    filterNama: function(nama) {
      const tblData = this.tblData;
      const refresh = this.refresh;
      setTimeout(() => {
        if (nama == tblData.nama) refresh();
      }, 500);
    },    
  },
  props: ["model"],
  created: async function() {
      this.dimension.forEach(dim => {
         if (!(this.model[`${dim.value}Info`])) {
          this.model[`${dim.value}Info`]=this.model[`${dim.value}info`]
         }
      });
  },

  methods: {
    onFiltered(filteredItems) {
      this.tblData.total = filteredItems.length;
    },
    data: async function(ctx) {
      this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
      this.tblData.DimColName = this.tblData.DimColName;

      return await dim.lookup(this.tblData);
    },
    showLkuDimVal(dim) {
      if (this.tblData.DimColName!=dim.value.trim())
      {
        this.tblData.DimColName=dim.value.trim();
        if (this.$refs.table) {
            this.refresh();
        } else {
          setTimeout(() => {
            this.refresh();
          }, 500);
        }
      }
      this.lkuDimTitle= `Lookup ${dim.text}`;
      this.lkuDimShow=true;
    },
    selectItem(item,index) {
      // 'item' will be the row data from items
      // `index` will be the visible row number (available in the v-model 'shownItems')
      this.model[item.DimColName]=item.kode;
      this.model[`${item.DimColName}Txt`]=item.nama;
      this.model[`${item.DimColName}Info`]=`${item.kode.trim()} | ${item.nama}`;
      this.lkuDimShow=false;
    },
    refresh(ctx) {
      this.$refs.table.refresh();
    }
  }
};
</script>
